module.exports = __webpack_public_path__ + "media/images/flags/ga-70dbf886482af6da540a7665da12ef80.svg";